import React, { FC, useEffect, useState } from 'react'
import CountUp from 'react-countup'
import { useSelector } from 'react-redux'
import { useResponsive } from '../../hooks'
import { ValuationBarProgress } from '../../@types/valuationBarProgress'
import { Status } from '../../@types/status'
import { toCurrency } from '../../utils/currencyFormat'
import { StyledValuationBar } from '../styled/ValuationBar/StyledValuationBar'
import { ReduxState } from '../../store/reducers'
import './ValuationBar.scss'

export interface ValuationProps {
  progress: ValuationBarProgress
  valuationAmountClass?: string
  largeValuationBar?: boolean
  informationMessage?: string
}

const counterDuration = 0.75

export const ValuationBar: FC<ValuationProps> = ({
  progress,
  valuationAmountClass,
  largeValuationBar,
  informationMessage,
}) => {
  const { isMobile } = useResponsive()
  const {
    config: { theme },
    valuation,
  } = useSelector((state: ReduxState) => state)

  const isStartProgress = () => {
    return progress.previousBound === 100
  }
  const [narrowValueForAnimation, setNarrowValueForAnimation] = useState<number>(
    isStartProgress() ? progress.currentBound : progress.previousBound
  )

  useEffect(() => {
    triggerAnimation()
  }, [])

  const triggerAnimation = () => {
    setTimeout(() => {
      if (!isStartProgress()) {
        setNarrowValueForAnimation(progress.currentBound)
      }
    }, counterDuration * 1000)
  }

  const formatPrice = ({ start, price }: { start: number; price: number }) => {
    return valuation.status === Status.SUCCESS ? (
      <span>
        <CountUp start={start} end={price} duration={counterDuration} separator='.' suffix=' €' />
      </span>
    ) : (
      <span>{toCurrency(price)}</span>
    )
  }

  const narrowMiddleInPercent = () => {
    return narrowValueForAnimation
  }

  const narrowMarginInPercent = () => {
    return (100 - narrowValueForAnimation) / 2
  }

  const getValuationAmountClass = () => {
    return valuationAmountClass || (isMobile ? 'font-bold font-xs' : 'font-s')
  }

  return !valuation.data ? (
    <div className='align-center font-semibold margin-top-l'>
      <h4>Der Wert konnte nicht ermittelt werden</h4>
    </div>
  ) : (
    <div>
      <div className=' grid grid-flex grid-justify-center valuation-big'>
        <div className='grid-item one-whole margin-bottom-s align-center'>
          <div className={getValuationAmountClass()} data-testid='valuation-amount-container'>
            {formatPrice({
              start: valuation?.data?.prevRange?.min ?? 0,
              price: valuation?.data?.range?.min ?? 0,
            })}{' '}
            -{' '}
            {formatPrice({
              start: valuation?.data?.prevRange?.max ?? 0,
              price: valuation?.data?.range?.max ?? 0,
            })}
          </div>
        </div>
        <StyledValuationBar
          width={narrowMiddleInPercent()}
          left={narrowMarginInPercent()}
          largeValuationBar={largeValuationBar}
          informationMessage={informationMessage}
          isMobile={isMobile}
          backgroundColor={theme?.primaryLight}
          progressColor={theme?.primary}
        />
      </div>
    </div>
  )
}

export default ValuationBar
